var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "#4BBFEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "white",
    fillOpacity: 0.56
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    stroke: "#0090CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7259 30.759C37.7466 29.7936 36.9696 28.9998 36.004 28.9998C35.0387 28.9998 34.262 29.7929 34.2821 30.7579L34.5059 41.507C34.5228 42.3203 35.187 42.9708 36.0005 42.9708C36.8136 42.9708 37.4776 42.3209 37.495 41.5079L37.7259 30.759Z",
    fill: "#0090CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5818 48.3814C34.9757 48.7936 35.4485 48.9998 36 48.9998C36.3636 48.9998 36.6939 48.9064 36.9909 48.7196C37.2939 48.5263 37.5364 48.2687 37.7182 47.9466C37.9061 47.6246 38 47.2671 38 46.8741C38 46.2944 37.8 45.7985 37.4 45.3862C37.0061 44.974 36.5394 44.7679 36 44.7679C35.4485 44.7679 34.9757 44.974 34.5818 45.3862C34.1939 45.7985 34 46.2944 34 46.8741C34 47.4667 34.1939 47.9692 34.5818 48.3814Z",
    fill: "#0090CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2214 19.3996C39.1714 15.5785 33.712 15.5219 31.5832 19.2996L15.9742 46.999C13.9082 50.6654 16.5574 55.1992 20.7658 55.1992H51.2352C55.3932 55.1992 58.0474 50.763 56.0818 47.099L41.2214 19.3996ZM34.1968 20.7724C35.1645 19.0553 37.646 19.081 38.5778 20.8179L53.4382 48.5173C54.3317 50.1827 53.1252 52.1992 51.2352 52.1992H20.7658C18.8529 52.1992 17.6487 50.1384 18.5878 48.4718L34.1968 20.7724Z",
    fill: "#0090CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.89b62b7615f055acbbd7a8ce32bd5456.svg";
export { ForwardRef as ReactComponent };